import { api } from "./api";
import { collectImageSrcs, type ChapterOfflineBundle } from "./chaptersApi";
import { saveAssets, saveBundle } from "./offlineChapters";

/**
 * Saves one chapter for offline reading: its notes and quiz in order, then its figure images (public files; a missing one
 * falls back to the alt text). `onProgress` gets 0-100. Throws when the chapter itself cannot be fetched or stored.
 */
export async function downloadChapter(
  token: string,
  userId: string,
  chapterId: string,
  onProgress?: (percent: number) => void,
): Promise<ChapterOfflineBundle> {
  onProgress?.(5);
  const bundle = await api.student.chapters.offlineBundle(token, chapterId);
  await saveBundle(userId, bundle);
  onProgress?.(50);
  const srcs = collectImageSrcs(bundle.notes);
  const files: Record<string, Blob> = {};
  for (const [i, src] of srcs.entries()) {
    try {
      files[src] = await api.student.chapterAsset(token, chapterId, src, bundle.version);
    } catch {
      /* offline reading shows the alt text for this image */
    }
    onProgress?.(50 + Math.round(((i + 1) / srcs.length) * 45));
  }
  await saveAssets(userId, chapterId, bundle.version, files).catch(() => undefined);
  onProgress?.(100);
  return bundle;
}
